// extracted by mini-css-extract-plugin
export default {"selectedItem":"settingsMenuStyle_selectedItem__JBbYN","wrapper":"settingsMenuStyle_wrapper__Xw+l7"};